module.exports = __webpack_public_path__ + "img/AdsClickOutlined.4e0ed387.svg";